import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { Trans } from "@devowl-wp/react-frontend";
import { useServiceDataProcessingCountriesSpecialTreatments } from "./useDataProcessingCountries.js";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateDataProcessingInCountriesSpecialTreatment() {
    const { t } = useTranslation();
    const { specialTreatments, bySelectedCountries } = useServiceDataProcessingCountriesSpecialTreatments();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.DataProcessingInCountriesSpecialTreatments,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || JSON.stringify(prev.dataProcessingInCountries) !== JSON.stringify(next.dataProcessingInCountries),
            noStyle: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                const dataProcessingInCountries = getFieldValue(ServiceTemplateField.DataProcessingInCountries);
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        hidden: dataProcessingInCountries.length === 0,
                        label: getFieldNameTranslated(ServiceTemplateField.DataProcessingInCountriesSpecialTreatments, t),
                        shouldUpdate: (prev, current)=>prev !== current,
                        children: /*#__PURE__*/ _jsxs(TemplateMetaDataExtendsStrategyFormField, {
                            extendsFieldName: ServiceTemplateField.DataProcessingInCountriesSpecialTreatments,
                            disableStrategies: getDisableStrategies(),
                            onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                                    disabled: true,
                                    defaultValue: extended?.dataProcessingInCountriesSpecialTreatments,
                                    options: specialTreatments
                                })
                            }),
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: `${process.env.ANTD_PREFIX}-form-item-extra`,
                                    style: {
                                        margin: "0px 0px 10px 0px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Trans, {
                                        children: [
                                            "You have selected countries which are probably considered as unsafe in different territorial legal basis. If you activate one of this special treatment options, you do not ask for consent according to",
                                            " ",
                                            /*#__PURE__*/ _jsx("a", {
                                                href: t("https://gdpr-text.com/read/article-49/"),
                                                rel: "noreferrer",
                                                target: "_blank",
                                                children: "Art. 49 GDPR"
                                            }),
                                            ", or the equivalent in DSG (Switzerland), if this kind of consent is activated at all in the settings."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    dependencies: [
                                        ServiceTemplateField.DataProcessingInCountries
                                    ],
                                    name: ServiceTemplateField.DataProcessingInCountriesSpecialTreatments,
                                    children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                                        options: bySelectedCountries(dataProcessingInCountries)
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateDataProcessingInCountriesSpecialTreatment };
